import { TableColumnContainer, TableItemContainer, TableItemTextView, TableView } from "components/shared";
import React from "react";
import TransferTemplatesTableAccordion from "../TransferTemplatesTableAccordion";

import "./styles.css"

/**
 * @function TransferTemplatesTable
 * @param {STRING} numOfItems - Displays the number of template items. 
 * @return {React.Component}
 * @exported true
 * @description This is the transfer template table shown in TransferTemplatesPage
 */
export default function TransferTemplatesTable(props) {
    const templates = props.templates ?? [];
    const numOfTemplates = templates.length;

    const rows = templates.reduce((acc, item) => {
        acc.push(
            <TransferTemplatesTableAccordion key={ item.id } template={ item } />
        );
        return acc;
    }, []);

    return (
        <TableView className="transfer-templates-table">
            <TableColumnContainer className="transfer-templates-header">
                <TableItemTextView className="chevron-col text-center" />
                <TableItemTextView className="template-name-col" text="Template Name" />
                <TableItemTextView className="account-from-col" text="From" />
                <TableItemTextView className="account-to-col" text="To" />
                <TableItemTextView className="default-amount-col text-right" text="Default Amount" />
            </TableColumnContainer>
            { rows }
            <tfoot className="transfer-templates-footer text-center" >
                <tr>
                    <td colSpan="6">{ 1 } - { numOfTemplates }  of { numOfTemplates } items</td>
                </tr>
            </tfoot>
        </TableView>
    )
}
